'use client';

import { Badge, Icon, Typography } from '@polyseme/design-system';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { images } from '~/landing/assets';
import { Button } from '~/landing/components/shared';

type HeroSectionProps = {
  goToDemo: () => void;
};

export const HeroSection = ({ goToDemo }: HeroSectionProps) => {
  const t = useTranslations('landing.germen.simulator');

  return (
    <div className="flex w-full flex-col gap-10 pb-16" id="hero">
      <div className="flex flex-col gap-4">
        <h1 className="whitespace-pre-wrap text-center text-3xl font-medium md:text-4xl lg:text-7xl">
          {t.rich('hero.title', {
            b: (chunk) => <span className="text-[#06D578]">{chunk}</span>,
          })}
        </h1>
        <div className="flex flex-wrap justify-center gap-3">
          <Badge size="lg" variant="neutral">
            <Typography>{t('hero.badges.lifeInsurance')}</Typography>
          </Badge>
          <Badge size="lg" variant="neutral">
            <Typography>{t('hero.badges.retirementSavings')}</Typography>
          </Badge>
        </div>
      </div>
      <div>
        <Image
          unoptimized
          alt={t('hero.alt')}
          className="h-auto w-full rounded-3xl object-cover"
          height={481}
          src={images.germen['simulator-hero']}
          width={1334}
        />
      </div>
      <div className="flex justify-center">
        <Button className="w-full md:w-auto" size="xl" onClick={goToDemo}>
          {t('presentation.carousel.cta')}
          <Icon name="bar-chart" />
        </Button>
      </div>
    </div>
  );
};
